import { defineMessages } from 'react-intl-next';

export default defineMessages({
	breadCrumbTitle: {
		id: 'dev-agents.app.settings.code-planner.code-planner-settings.bread-crumb-title',
		defaultMessage: 'Enable automatic coding plans',
		description: 'The title of breadcrumb item for the code planner agent settings page',
	},
	pageDescription: {
		id: 'dev-agents.app.settings.code-planner.code-planner-settings.page-description',
		defaultMessage:
			'Code Planner can automatically create coding plans for work items in a project. When this setting is enabled for a project, every new coding-related work item created will automatically have a coding plan created and added to the work item. Code Planner can still create coding plans manually, whether this setting is enabled or not. You must be a Rovo Dev Agents admin to enable automatic coding plans on a project.',
		description: 'The description of code planer agent displayed on the page.',
	},
	pageLoadingMessage: {
		id: 'dev-agents.app.settings.code-planner.code-planner-settings.page-loading-message',
		defaultMessage: 'Loading...',
		description: 'The message displayed when the page is loading',
	},
});
